module.exports = __webpack_public_path__ + "img/icon-line.08a4f24a.svg";